"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableRow = void 0;
var react_1 = __importDefault(require("react"));
function parityClass(parity) {
    return parity === "odd" ? "bg-grey-lighter" : "bg-white";
}
var MOUSE_OVER_CLASS = "bg-yellow-lighter";
var DataTableRow = /** @class */ (function (_super) {
    __extends(DataTableRow, _super);
    function DataTableRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { mouseOver: false };
        _this.handleMouseOver = _this.handleMouseOver.bind(_this);
        _this.handleMouseOut = _this.handleMouseOut.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    DataTableRow.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("tr", { onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut, onClick: this.handleClick }, this.props.formatFunction(this.props.element).map(function (field, i) { return (react_1.default.createElement("td", { key: i, className: "p-4 align-top text-grey-darker ".concat(_this.state.mouseOver
                ? MOUSE_OVER_CLASS
                : parityClass(_this.props.parity), " ") }, field)); })));
    };
    DataTableRow.prototype.handleMouseOver = function () {
        this.setState({ mouseOver: true });
    };
    DataTableRow.prototype.handleMouseOut = function () {
        this.setState({ mouseOver: false });
    };
    DataTableRow.prototype.handleClick = function (e) {
        this.props.onClick && this.props.onClick(e);
    };
    return DataTableRow;
}(react_1.default.Component));
exports.DataTableRow = DataTableRow;
